import React, { useState,useEffect } from 'react';
import figure13 from "../../../assets/images/shared/Icon-Search.png";

import { useMediaQuery } from 'react-responsive';
import figure1 from "../../../assets/images/icons/menu/filtros.png";
import { getVisit } from "../../../client/administration/board/index";

const Filter = ({ setFilteredRecords ,records, setSelectedCompany,filterPlate,setPlate, setSearchTerm}) => {
  const [placa, setPlaca] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const is412px = useMediaQuery({ minWidth: 400,maxWidth: 834 });

  const fetchVisitas = async () => {
    try {
      const { data } = await getVisit();
      const uniqueCompanies = [...new Set(data.map(record => record.companyName))];
      setCompanies(uniqueCompanies); 
    } catch (err) {
      console.error("Error fetching visits:", err);
    }
  };

  useEffect(() => {
    fetchVisitas();
  }, []);

   /** FILTRAR POR EMPRESA */
  const handleFilterByEmpresa = (company) => {
    setSelectedCompany(company);
    const filtered = records.filter(record => record.companyName && record.companyName.includes(company));
    setFilteredRecords(filtered);
  };

  /** FILTRAR POR PLACA */

  const handleFilterByPlate = (value) => {
    setPlaca(value);
    console.log("Valor de placa ingresado:", value);
    setPlate(value); 
    const filtered = records.filter(record => 
      record.plate && 
      record.plate.toLowerCase().includes(value.toLowerCase()) // Filtrar por placa
    );
    console.log("Registros filtrados por placa:", filtered);
    setFilteredRecords(filtered); 
  };

  const handleFilterSearch = (term) => {
    setSearch(term);
    setSearchTerm(term);
  
    const filtered = records.filter((record) => {
      const categoryName = record.categoryName || "";
      const plate = record.plate || "";
      const driverName = record.driverName || "";
      const dni = record.dni || "";
      const companyName = record.companyName || "";
  
      return (
        categoryName.toLowerCase().includes(term.toLowerCase()) ||
        plate.toLowerCase().includes(term.toLowerCase()) ||
        driverName.toLowerCase().includes(term.toLowerCase()) ||
        dni.toLowerCase().includes(term.toLowerCase()) ||
        companyName.toLowerCase().includes(term.toLowerCase())
      );
    });
  
    setFilteredRecords(filtered);
  };
  
  const handleResetFilters = () => {
    setPlaca(''); 
    setEmpresa(''); 
    setSelectedCompany('');
    setSearch('');
    setFilteredRecords(records);
  };
  

  return (
    <div className="relative flex justify-between items-center  ">
      <div className="relative  md:w-[368px] des:w-[1003px]">
        <div className="flex items-center border border-[#76A140] rounded-[3px] ">
          <img
            src={figure13}
            alt="Buscar"
            className="w-5 h-5 ml-3"
          />
          <input
            type="text"
            placeholder="Buscar por Placa/Conductor/Dni/Empresa"
            value={search}
            className="px-3 py-2 focus:outline-none w-[331px] md:w-[368px] des:w-[1023px] font-itcbook text-[15px] placeholder:text-[#76A140]"
            onChange={(e) => handleFilterSearch(e.target.value)}
          />
        </div>
      </div>

      {/* Botón de hamburguesa para pantallas pequeñas */}
      {is412px && (
        <div className="flex items-center">
        <button
          className="flex items-center justify-center w-8 h-8 md:hidden focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <img src={figure1} alt="filtros" className="w-[16px] h-[18px]" />
        </button>
        <span className="ml-2 text-[#76A140] font-itcbook text-[14px]">
          Más filtros
        </span>
      </div>
      )}

      {is412px && menuOpen && (
        <div className="absolute top-full right-0 mt-2 bg-white border border-[#76A140] rounded shadow-lg w-80">
          <div className="flex flex-col p-4">
            {/*<input
              type="text"
              placeholder="Filtrar por placa"
              className="border border-[#76A140] rounded-[4px] w-full placeholder:text-[#76A140] font-itcbook text-[14px] px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500 mb-2"
              value={placa}
              onChange={(e) => handleFilterByPlate(e.target.value)}
            />*/}

            <select
              className="border text-[#76A140] border-[#76A140] rounded-[4px] w-full font-itcbook text-[14px] px-4 py-2 focus:outline-none mb-2 appearance-none"
              value={empresa}
              onChange={(e) => handleFilterByEmpresa(e.target.value)}
              style={{
                backgroundImage: `
                linear-gradient(to right, transparent 0%, transparent calc(100% - 1.5rem), #76A140 calc(100% - 1.5rem), #76A140 100%),
                url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")
                 `,
                backgroundPosition: "left 15rem center, right 1rem center",
                backgroundSize: "1px 100%, 1rem",
                backgroundRepeat: "no-repeat",
            }}
            >
              <option className="text-[#76A140] text-[13px] font-itcbook placeholder:text-[#76A140]" value="">Filtrar por empresa</option>
              {companies.map((company, index) => (
                <option key={index} value={company} className="text-[13px] font-itcbook">{company}</option>
              ))}
            </select>

            <button
              onClick={handleResetFilters}
              className="border text-[#76A140] rounded-[5px] px-4 py-2 text-[14px] w-full font-itcmedium hover:bg-green-600"
            >
              Reiniciar filtros
            </button>
          </div>
        </div>
      )}

      {/* Para pantallas más grandes, se muestra el menú de filtro original */}
      {!is412px && (
        <div className="flex justify-end space-x-4 text-[#76A140]">
          {/*<input
            type="text"
            placeholder="Filtrar por placa"
            className="border placeholder:text-[#76A140] border-[#76A140] text-[#76A140] rounded-[4px] w-[170px] font-itcbook text-[14px] px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
            value={placa}
            onChange={(e) => handleFilterByPlate(e.target.value)}
          />*/}

          <select
            className="border text-[#76A140] border-[#76A140] appearance-none rounded-[4px] w-[213px] font-itcbook text-[14px] px-4 py-2 focus:outline-none "
            value={empresa}
            options={empresa}
            onChange={(e) => handleFilterByEmpresa(e.target.value)}
            style={{
                backgroundImage: `
                linear-gradient(to right, transparent 0%, transparent calc(100% - 1.5rem), #76A140 calc(100% - 1.5rem), #76A140 100%),
                url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")
                 `,
                backgroundPosition: "left 10.5rem center, left 11.5rem center",
                backgroundSize: "1px 100%, 1rem",
                backgroundRepeat: "no-repeat",
            }}
          >
           <option className="text-[#76A140] text-[13px] w-[200px] font-itcbook border-green bg-white " value="" disabled >Filtrar por empresa</option>
              {companies.map((company, index) => (
                <option key={index} value={company} className="text-[13px] font-itcbook w-[213px] text-[#76A140]  ">{company}</option>
              ))}
          </select>

          <button
            onClick={handleResetFilters}
            className="border text-[#76A140] rounded-[5px] px-4 py-2 text-[14px] w-[137px] font-itcmedium hover:bg-green-600"
          >
            Reiniciar filtros
          </button>
        </div>
      )}
    </div>
  );
};

export default Filter;
